import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import { toCdn } from '../utils/cdn';

export default function SwiftUI() {
  const meta = projectMeta.swiftui;
  const videos = [
    'finderCam',
    'glassText',
    'magnify',
    'movies',
    'chatheads',
    'filmFinder',
    'color',
    'dots',
    'gooeyButton',
    'beforeAfterSlider',
    'colorPalette',
    'chunkyButtons',
    'dial',
    'wifiChecker',
    'matrixSelector',
    'explode',
    'wand',
    'trail',
    'ai',
    'widget',
  ];
  React.useEffect(() => {
    const container = document.getElementById('swiftui-gallery');
    if (!container) return;
    const vids = Array.from(container.querySelectorAll('video.gallery-item'));

    const ensureAttrs = (v) => {
      try {
        v.muted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;
        v.setAttribute('playsinline', '');
      } catch (_) {}
    };

    const onIntersect = (entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        ensureAttrs(v);
        if (entry.isIntersecting) {
          try { const p = v.play(); if (p && typeof p.then === 'function') p.catch(() => {}); } catch (_) {}
        } else {
          try { v.pause(); } catch (_) {}
        }
      });
    };

    const io = new IntersectionObserver(onIntersect, { root: null, rootMargin: '300px 0px', threshold: 0.01 });
    vids.forEach((v) => io.observe(v));
    // Immediately attempt to play any already in view
    const playIfInView = () => {
      vids.forEach((v) => {
        const r = v.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
        if (inView) {
          try { const p = v.play(); if (p && typeof p.then === 'function') p.catch(() => {}); } catch (_) {}
        }
      });
    };
    try { playIfInView(); } catch(_) {}
    return () => { try { io.disconnect(); } catch (_) {} };
  }, []);

  // Preload top posters eagerly via <link rel="preload"> for faster first paint
  React.useEffect(() => {
    const container = document.getElementById('swiftui-gallery');
    if (!container) return;
    const posters = Array.from(container.querySelectorAll('video.gallery-item'))
      .map((v) => v.getAttribute('poster'))
      .filter(Boolean);
    const head = document.head || document.getElementsByTagName('head')[0];
    const links = [];
    posters.slice(0, 8).forEach((url) => {
      try {
        const l = document.createElement('link');
        l.rel = 'preload';
        l.as = 'image';
        l.href = url;
        try { l.fetchPriority = 'high'; } catch(_) {}
        head.appendChild(l);
        links.push(l);
      } catch (_) {}
    });
    return () => {
      links.forEach((l) => { try { head.removeChild(l); } catch(_) {} });
    };
  }, []);
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      <div
        id="swiftui-gallery"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(var(--swiftui-cols, 4), 1fr)',
          gap: '16px'
        }}
      >
        {videos.map((name, i) => (
          <div key={name} className="video-mask">
            <video
              src={toCdn(`/images/projects/swiftui/${name}.mp4`)}
              poster={toCdn(`/images/projects/swiftui/${name}_poster.webp`)}
              alt={name}
              className="gallery-item"
              preload={i < 4 ? 'auto' : 'metadata'}
              autoPlay
              muted
              playsInline
              loop
              style={{ aspectRatio: '5 / 8', objectFit: 'cover' }}
            />
          </div>
        ))}
      </div>
    </ProjectDetail>
  );
}
